import { render, staticRenderFns } from "./Alibaba-buyer-myself.vue?vue&type=template&id=6e1c9619&"
import script from "./Alibaba-buyer-myself.vue?vue&type=script&lang=js&"
export * from "./Alibaba-buyer-myself.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports